/**
 * 149-cw-r5: Relative-time helper for presence display.
 * Renders "5 menit lalu" / "hari ini, 14:32" / "23 Aug 2026, 18:10".
 */
export function fmtRelativeLastSeen(isoString) {
  if (!isoString) return "belum pernah";
  let d;
  try { d = new Date(isoString); } catch { return "—"; }
  if (isNaN(d.getTime())) return "—";
  const now = new Date();
  const diffSec = Math.floor((now.getTime() - d.getTime()) / 1000);
  if (diffSec < 0) return "baru saja";
  if (diffSec < 60) return "baru saja";
  if (diffSec < 3600) {
    const m = Math.floor(diffSec / 60);
    return `${m} menit lalu`;
  }
  // Same calendar day → "hari ini, HH:MM"
  const sameDay =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate();
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  if (sameDay) return `hari ini, ${hh}:${mm}`;
  // Within past 7 days → "3 hari lalu, HH:MM"
  if (diffSec < 7 * 24 * 3600) {
    const days = Math.floor(diffSec / (24 * 3600));
    return `${days} hari lalu, ${hh}:${mm}`;
  }
  // Older → "23 Agu 2026, 18:10"
  const MONTHS = ["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"];
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}, ${hh}:${mm}`;
}

/**
 * 149-cw-r115 (2026-08-29): Explicit day-name + date + time format for presence.
 * Hasil: "Kamis, 29 Agu · 15:32" (same year) / "Kamis, 29 Agu 2026 · 15:32" (different year)
 * atau "kemarin, 15:32" bila hari sebelumnya.
 * Dipakai di Pesan Internal supaya user langsung tahu HARI + JAM eksak akun terakhir online,
 * bukan hanya "5 menit lalu" (relative).
 */
export function fmtLastSeenExact(isoString) {
  if (!isoString) return "belum pernah";
  let d;
  try { d = new Date(isoString); } catch { return "—"; }
  if (isNaN(d.getTime())) return "—";
  const now = new Date();
  const DAYS = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
  const MONTHS = ["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"];
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  const dayName = DAYS[d.getDay()];
  const sameDay =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate();
  if (sameDay) return `hari ini, ${hh}:${mm}`;
  // Cek "kemarin" (H-1 kalender)
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday =
    d.getFullYear() === yesterday.getFullYear() &&
    d.getMonth() === yesterday.getMonth() &&
    d.getDate() === yesterday.getDate();
  if (isYesterday) return `kemarin (${dayName}), ${hh}:${mm}`;
  const sameYear = d.getFullYear() === now.getFullYear();
  if (sameYear) return `${dayName}, ${d.getDate()} ${MONTHS[d.getMonth()]} · ${hh}:${mm}`;
  return `${dayName}, ${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()} · ${hh}:${mm}`;
}
